import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getEventDetails } from '@store/slices/eventSlice';
import { usePublicCoLocatedEventsByEventId } from '@utils/apiHooks';
import {
  CoLocatedStickyMenuWrapper,
  RotatedMenu,
  LogoListWrapper,
  LogoImage,
  MenuTitle,
  LogoWrapper,
  RotateIcon,
} from './styles';
import Icon from '@components/Icon';
import { getImageSrc } from '@utils/fn';
import { useSpring } from '@react-spring/web';

const CoLocatedStickyMenu = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const { data: coLocatedEvents } = usePublicCoLocatedEventsByEventId({
    eventId: sluggedEvent?.id,
    enabled: sluggedEvent?.id?.length > 0 && sluggedEvent?.colocated,
  });

  const [showMenu, setShowMenu] = useState(false);
  const [showList, setShowList] = useState(false);

  useEffect(() => {
    if (sluggedEvent?.colocated) {
      setShowMenu(true);
    }
  }, [sluggedEvent]);

  const textColor = theme.color.white;
  const props = useSpring({
    from: { transform: 'rotateZ(0deg)' },
    to: { transform: 'rotateZ(-180deg)' },
    config: { duration: 600 },
    reverse: !showList,
  });

  return (
    <>
      {showMenu && (
        <CoLocatedStickyMenuWrapper showList={showList}>
          <RotatedMenu
            onClick={() => {
              setShowList(v => !v);
            }}
          >
            <MenuTitle>{t('co-located-events')}</MenuTitle>
            <RotateIcon style={props}>
              <Icon
                size={24}
                color={textColor}
                name="caret_arrow_left"
                indentLess
              />
            </RotateIcon>
          </RotatedMenu>

          <LogoListWrapper showList={showList}>
            {coLocatedEvents
              ?.filter(ev => ev.id !== sluggedEvent?.id)
              ?.map(ev => (
                <LogoWrapper
                  key={ev.id}
                  onClick={() => {
                    window.location.href = `${window.location.origin}/events/${ev?.slug}`;
                  }}
                >
                  <LogoImage
                    src={getImageSrc(ev?.design?.eventLogoPosSvg)}
                    alt={ev.name}
                    title={ev.name}
                  />
                </LogoWrapper>
              ))}
          </LogoListWrapper>
        </CoLocatedStickyMenuWrapper>
      )}
    </>
  );
};
export default CoLocatedStickyMenu;
